export default "__VITE_ASSET__BAV4SfGo__"